import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Tags.module.scss';

export default class Tags extends Component {
  static defaultProps = {
    className: '',
    tags: []
  };

  static propTypes = {
    className: PropTypes.string,
    tags: PropTypes.array
  };

  render() {
    const { className, tags } = this.props;
    return (
      <div className={`${styles.Tags} ${className}`}>
        {tags.map(tag => (
          <div key={tag.codename} className={styles.TagWrapper}>
            <p className={styles.Tag}>{tag.name}</p>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Tags/Tags.js